<style scoped>
  .TVChartContainer {
    height: 508px;
    border-radius: 5px 5px 0 0;
    overflow: hidden;
    background-color: var(--color-chart);
  }

  .msg {
    font-size: 16px;
    border: 1px solid gray;
    border-radius: 5px;
    margin-bottom: 10px;
  }

  .dragger {
    height: 17.5px;
    cursor: ns-resize;
    position: relative;
    margin-top: -5.5px;
    margin-bottom: -12px;
    user-select: none;
  }

  .dragger img {
    position: relative;
    top: -2px;
  }

  .dragger-active::after {
    content: '';
    position: absolute;
    left: 7px;
    right: 7px;
    top: 8px;
    height: 2px;
    background-color: rgba(74, 144, 217, 0.75);
    box-shadow: 0 0 6px rgba(74, 144, 217, 0.45);
    border-radius: 1px;
    z-index: -1;
  }

  .resizing1 {
    pointer-events: none;
  }

  .ticker {
    border-radius: 0 0 5px 5px;
    border-top: 1px solid var(--color-chart-border);
  }
</style>

<template>
  <div @mouseleave="onDraggerLeave">
      <div v-show="showChart" class="TVChartContainer" :class="{ resizing1 : resizing }" :id="containerId"></div>
      <SymbolTicker class="ticker" mode="bots" />
      <div v-show="showChart" class="dragger" :class="{ 'dragger-active': resizing }" @mousedown="initResize"><img src="@/assets/dragger2.png" draggable="false" /></div>
    <div v-if="$store.state.sys.tradeExchange.ExchId && !showChart" class="msg" style="margin-top: 15px; padding: 10px">
      <span style="font-size: 17px">{{ unavailableMessage }}</span>
    </div>
  </div>
</template>

<script>
import Botdatafeed from '@/services/botdatafeed/'
import { widget } from '@/lib/charting_library'
import { sha256 } from 'js-sha256'
import constants from '@/util/constants'
import Decimal from 'decimal.js'
import Api from '@/util/api'
import Bots from '@/services/bots'
import BotApi from '@/util/botapi'
import Data from '@/util/data'
import $store from '@/store/index'
import Util from '@/util/util'
// import MobileDetect from 'mobile-detect'
import SymbolTicker from '@/components/common/SymbolTicker'

const pstate = {
  tvWidget: null,
  buyLine: null,
  sellLine: null,
  slLine: null,
  triggerLine: null,
  orderArrows: [],
  otherBuySellLines: [],
  viewModeBuySellLines: [],
  orders: [],
  filledOrders: [],
  resetExmoInterval: null
}

export default {
  name: 'BotTV',
  components: {
    SymbolTicker
  },
  data: function () {
    return {
      element: null,
      resizing: false,
      startY: 0,
      startHeight: 0,
      containerId: 'bot_tv_chart_container',
      prevState: '',
      tvReady: false
    }
  },
  computed: {
    tradeExchOrSymbolChanged () {
      // eslint-disable-next-line
      let a = this.$store.state.sys.tradeExchange.Id
      // eslint-disable-next-line
      let b = this.eb.symbol

      return Date.now()
    },
    chartSymbol () {
      return constants.exchangeTVIds[this.$store.state.sys.tradeExchange.ExchId] + ':' + this.$store.state.bots.symbol.replace('_', '/')
    },
    eb () {
      return this.$store.state.bots
    },
    exchName () {
      return constants.exchangeTVIds[this.$store.state.sys.tradeExchange.ExchId]
    },
    exchDisplayName () {
      const exchId = this.$store.state.sys.tradeExchange.ExchId
      if (exchId === 'OKX') return 'OKX'
      return constants.exchangeNewIds[exchId]
    },
    unavailableMessage () {
      return this.$text.tr('Боты для {name} недоступны').replace('{name}', this.exchDisplayName)
    },
    showChart () {
      const validEids = ['BIN', 'BIM', 'HUO', 'EXM', 'FTX', 'OKX']
      if (validEids.includes(this.$store.state.sys.tradeExchange.ExchId)) {
        return true
      }
      return false
    }
  },
  watch: {
    '$store.state.sys.email' (email) {
      if (this.showChart) {
        this.startBotChart()
      }
    },
    'eb.showArrors' () {
      // console.log('show arrors changed')
      this.redrawOrderArrows()
    },
    // '$store.state.sys.tradeExchange' () {
    // if (!this.tvReady) {
    //   return
    // }
    // var z = () => {
    //   console.log('z called')
    //   this.cleanTV()
    //   pstate.tvWidget.chart().setSymbol(this.chartSymbol, () => {
    //     console.log('symbol loaded!!!')
    //     // this.saveNeeded()
    //   })
    // }
    // this.$store.dispatch('updateSymbols', { z }).then(() => {
    //   console.log('updateSymbols dispatch done222')
    // })
    // console.log('botTV tradeExchange changed')
    // },
    // 'eb.setSymbolNeeded' () {
    //   if (!this.tvReady) {
    //     return
    //   }
    //   pstate.tvWidget.chart().setSymbol(this.chartSymbol, () => {
    //     // console.log('exch & symbol change loaded')
    //     // this.saveNeeded()
    //   })
    // },
    'tradeExchOrSymbolChanged' () {
      // console.log('tradeExchOrSymbolChanged', this.$store.state.sys.tradeExchange.Id, this.eb.symbol)

      // if (!this.tvReady) {
      //   Api.get('user/tvdata?cmd=load&token=' + this.$store.state.sys.token, { transformResponse: res => res })
      //     .then(res => {
      //       this.createBotChart(res.data)
      //     })
      //     .catch(error => {
      //       console.log(error)
      //     })
      //   return
      // }
      // console.log('setSymbol', this.chartSymbol)
      if (!pstate.tvWidget || !pstate.tvWidget._ready || !pstate.tvWidget.chart()) {
        return
      }
      pstate.tvWidget.chart().setSymbol(this.chartSymbol, () => {
        // console.log('symbol change loaded')
        // this.saveNeeded()
      })
      if (!this.eb.editMode) {
        // console.log('eb.symbol chahged')
        this.cleanTV()
        this.getExecutedBotOrders()
        // setTimeout(() => {
        //   this.addViewModeBuySellLines()
        // }, 1000)
      } else {
        setTimeout(() => {
          this.addBotBuyLine()
          this.addBotSellLine()
          this.addBotSlLine()
          this.addBotTriggerLine()
        }, 100)
      }
      Bots.GetActiveBotList()
    },
    'eb.activeBotsList' (a, b) {
      // console.log('activeBotsList changed', a, b)
      if (!this.eb.editMode) {
        // console.log('eb.symbol chahged')
        this.getExecutedBotOrders()

        if (this.botsChanged(a, b)) {
          this.cleanTVNoArrows()
          this.addViewModeBuySellLines()
        }
      }
    },
    'eb.editMode' (editMode) {
      // console.log('editMode', editMode)
      this.cleanTV()
      if (editMode) {
      } else {
        this.eb.editBot = {}
        this.addViewModeBuySellLines()
        this.getExecutedBotOrders()
      }
    },
    'eb.editBot' (bot) {
      if (!this.tvReady) {
        return
      }
      if (!this.eb.editMode) {
        return
      }
      // console.log('bot changed', bot)
      this.getEditBotOrders()
      pstate.otherBuySellLines.forEach(a => a.remove())
      pstate.otherBuySellLines = []
      this.eb.activeBotsList.forEach(b => {
        if ((bot.Id !== b.Id && bot.Symbol === b.Symbol) ||
           (!bot.Id && this.$store.state.bots.symbol === b.Symbol)) {
          this.$nextTick(() => {
            if (b.Stage === 'WAITSELL') {
              this.addOtherBotSellLine(b)
            } else if (b.Stage === 'WAITBUY') {
              this.addOtherBotBuyLine(b)
            }
          })
        }
      })
      setTimeout(() => {
        this.addBotBuyLine()
        this.addBotSellLine()
        // this.addBotSlLine()
        // this.addBotSlLine()
        // this.addBotTriggerLine()
      }, 100)
    },
    // '$route123' (to, from) {
    // console.log('route:', to)
    // if (to.name === 'bots') {
    //   Api.get('user/tvdata?cmd=load&token=' + this.$store.state.sys.token, { transformResponse: res => res })
    //     .then(res => {
    //       if (res.data) {
    //         pstate.tvWidget.load(JSON.parse(res.data))
    //         // console.log('tvdata reaplied:')
    //       }
    //     })
    //     .catch(error => {
    //       console.log(error)
    //     })
    // }
    // if (from.name === 'bots') {
    // }
    // },
    // '$store.state.bots.symbol': function () {
    //   pstate.tvWidget.chart().setSymbol(this.chartSymbol, () => {
    //     // console.log('symbol loaded')
    //     this.saveNeeded()
    //   })
    // },
    'eb.buyPrice' () {
      if (!this.tvReady) {
        return
      }
      // console.log('buyPrice changed')
      this.$nextTick(() => {
        this.addBotBuyLine()
        this.addBotSellLine()
        this.addBotSlLine()
      })
    },
    'eb.sellPrice' () {
      if (!this.tvReady) {
        return
      }
      this.addBotSellLine()
    },
    'eb.slPrice' () {
      if (!this.tvReady) {
        return
      }
      this.addBotSlLine()
    },
    'eb.stopLoss' () {
      if (!this.tvReady) {
        return
      }
      this.addBotSlLine()
    },
    'eb.triggerPrice' () {
      if (!this.tvReady) {
        return
      }
      this.addBotTriggerLine()
    },
    'eb.trigger' () {
      if (!this.tvReady) {
        return
      }
      this.addBotTriggerLine()
    }
  },
  mounted () {
    const savedHeight = localStorage.getItem('capico_app_botTV_height')
    if (savedHeight) {
      this.$nextTick(() => {
        const el = document.getElementById(this.containerId)
        if (el) {
          el.style.height = savedHeight + 'px'
        }
      })
    }
    if (this.$store.state.sys.email !== '' & this.showChart) {
      this.startBotChart()
    }
  },
  beforeDestroy () {
    if (pstate.resetExmoInterval) {
      clearInterval(pstate.resetExmoInterval)
      pstate.resetExmoInterval = null
    }
    if (pstate.buyLine) pstate.buyLine.remove()
    if (pstate.sellLine) pstate.sellLine.remove()
    if (pstate.slLine) pstate.slLine.remove()
    if (pstate.triggerLine) pstate.triggerLine.remove()
    pstate.orderArrows.forEach(a => a.remove())
    pstate.otherBuySellLines.forEach(l => l.remove())
    pstate.viewModeBuySellLines.forEach(l => l.remove())
    pstate.orders.forEach(o => o.remove())
    if (pstate.tvWidget) {
      const oldWidget = pstate.tvWidget
      pstate.tvWidget = null
      oldWidget.remove()
    }
  },
  destroyed () {
    pstate.buyLine = null
    pstate.sellLine = null
    pstate.slLine = null
    pstate.triggerLine = null
    pstate.orderArrows = []
    pstate.otherBuySellLines = []
    pstate.viewModeBuySellLines = []
    pstate.orders = []
  },
  methods: {
    startBotChart () {
      this.createBotChart()
      // Api.get('user/tvdata?cmd=load&token=' + this.$store.state.sys.token, { transformResponse: res => res })
      //   .then(res => {
      //     this.createBotChart(res.data)
      //   })
      //   .catch(error => {
      //     console.log(error)
      //   })
    },
    addButtons () {
      if (pstate.tvWidget) {
        pstate.tvWidget.headerReady().then(() => {
          const arrowsBtn = pstate.tvWidget.createButton()
          arrowsBtn.style.color = '#8e65e6'
          if (this.eb.showArrows === true) {
            arrowsBtn.textContent = this.$text.tr('Bыкл') + ' ⇧'
          } else {
            arrowsBtn.textContent = this.$text.tr('Bкл') + ' ⇧'
          }

          arrowsBtn.addEventListener('click', () => {
            this.eb.showArrows = !this.eb.showArrows
            localStorage.setItem('capico_app_botTV_showArrows', this.eb.showArrows)
            arrowsBtn.textContent = this.eb.showArrows
              ? this.$text.tr('Bыкл') + ' ⇧'
              : this.$text.tr('Bкл') + ' ⇧'
            this.redrawOrderArrows()
          })

          const ordersBtn = pstate.tvWidget.createButton()
          ordersBtn.style.color = '#6b74e7'
          if (this.eb.showOrders) {
            ordersBtn.textContent = this.$text.tr('Bыкл') + ' ---'
          } else {
            ordersBtn.textContent = this.$text.tr('Bкл') + ' ---'
          }

          ordersBtn.addEventListener('click', () => {
            if (this.eb.editMode) {
              return
            }

            this.eb.showOrders = !this.eb.showOrders
            localStorage.setItem('capico_app_botTV_showOrders', this.eb.showOrders)

            if (this.eb.showOrders) {
              ordersBtn.textContent = this.$text.tr('Bыкл') + ' ---'
              this.addOrders()
            } else {
              ordersBtn.textContent = this.$text.tr('Bкл') + ' ---'
              this.cleanTVNoArrows()
            }
          })
        })
      }
    },
    addOrders () {
      this.addBotBuyLine()
      this.addBotSellLine()
      this.addBotSlLine()
      this.addBotTriggerLine()
      this.addViewModeBuySellLines()
    },
    stopResize (e) {
      window.removeEventListener('mousemove', this.resize, true)
      window.removeEventListener('mouseup', this.stopResize, false)
      this.resizing = false
      if (this.element) {
        localStorage.setItem('capico_app_botTV_height', parseInt(this.element.style.height))
      }
    },
    resize (e) {
      this.element.style.height = (this.startHeight + (e.clientY - this.startY)) + 'px'
    },
    onDraggerLeave (e) {
      if (this.resizing && e.clientY <= e.currentTarget.getBoundingClientRect().top) {
        this.element.style.height = '0px'
      }
    },
    initResize (e) {
      e.preventDefault()
      this.resizing = true
      this.element = document.getElementById(this.containerId)
      this.startY = e.clientY
      this.startHeight = this.element.offsetHeight
      window.addEventListener('mousemove', this.resize, true)
      window.addEventListener('mouseup', this.stopResize, false)
    },
    addViewModeBuySellLines () {
      if (!this.eb.showOrders) {
        return
      }

      this.eb.activeBotsList.forEach(b => {
        // console.log('activeBotsList item', b)
        if (this.eb.symbol === b.Symbol && b.Status === 'ACT') {
          this.$nextTick(() => {
            this.addViewModeBuySellLine(b)
          })
        }
      })
    },
    cleanArrows () {
      if (!pstate.tvWidget || !pstate.tvWidget._ready || !pstate.tvWidget.chart()) {
        return
      }
      pstate.orderArrows.forEach(a => {
        if (a) {
          pstate.tvWidget.chart().removeEntity(a)
        }
      })
      pstate.orderArrows = []
    },
    cleanTV () {
      this.cleanArrows()

      if (pstate.buyLine) {
        pstate.buyLine.remove()
        pstate.buyLine = null
      }

      if (pstate.sellLine) {
        pstate.sellLine.remove()
        pstate.sellLine = null
      }

      if (pstate.slLine) {
        pstate.slLine.remove()
        pstate.slLine = null
      }

      if (pstate.triggerLine) {
        pstate.triggerLine.remove()
        pstate.triggerLine = null
      }

      pstate.otherBuySellLines.forEach(a => a.remove())
      pstate.otherBuySellLines = []

      pstate.viewModeBuySellLines.forEach(a => a.remove())
      pstate.viewModeBuySellLines = []
    },
    cleanTVNoArrows () {
      if (pstate.buyLine) {
        pstate.buyLine.remove()
        pstate.buyLine = null
      }

      if (pstate.sellLine) {
        pstate.sellLine.remove()
        pstate.sellLine = null
      }

      if (pstate.slLine) {
        pstate.slLine.remove()
        pstate.slLine = null
      }

      if (pstate.triggerLine) {
        pstate.triggerLine.remove()
        pstate.triggerLine = null
      }

      pstate.otherBuySellLines.forEach(a => a.remove())
      pstate.otherBuySellLines = []

      pstate.viewModeBuySellLines.forEach(a => a.remove())
      pstate.viewModeBuySellLines = []
    },
    botsChanged (oldbots, newbots) {
      if (oldbots.length !== newbots.length) {
        return true
      }
      for (let i = 0; i < newbots.length; i++) {
        if (oldbots[i].Id !== newbots[i].Id ||
            oldbots[i].Stage !== newbots[i].Stage ||
            oldbots[i].Status !== newbots[i].Status ||
            oldbots[i].BuyPrice !== newbots[i].BuyPrice ||
            oldbots[i].SellPrice !== newbots[i].SellPrice) {
          return true
        }
      }
      return false
    },
    getExecutedBotOrders () {
      const ref = this
      BotApi.get('bot/exeorders', {
        params: {
          token: this.$store.state.sys.token,
          etid: this.$store.state.sys.tradeExchange.Id,
          symbol: this.eb.symbol
        }
      }).then(function (response) {
        // console.log('getExecutedBotOrders', response.data)
        if (response.data !== null) {
          if (!response.data.err) {
            pstate.filledOrders = response.data || []
            ref.redrawOrderArrows()
            // ref.botOrders = response.data
            // ref.botName = botName
            // ref.botSymbol = botSymbol
            // ref.botOrdersModalShow = true
          } else {
            // error
            ref.$Notice.error({
              title: ref.$text.tr('Ошибка'),
              desc: Util.returnTextForErr(response.data.err),
              duration: 10
            })
          }
        } else {
          // ref.$Notice.info({
          //   title: 'нет ордеров',
          //   duration: 1
          // })
        }
      }).catch(function (error) {
        // error
        console.log(error)
        ref.$Notice.error({
          title: ref.$text.tr('Ошибка'),
          desc: Util.returnTextForErr(error),
          duration: 10
        })
      })
    },
    getEditBotOrders () {
      if (!this.eb.editBot.Id) {
        return
      }
      const ref = this
      BotApi.get('bot/orders', {
        params: {
          token: this.$store.state.sys.token,
          id: this.eb.editBot.Id
        }
      }).then(function (response) {
        // console.log('orders', JSON.stringify(response.data))
        if (response.data !== null) {
          if (!response.data.err) {
            // ok
            pstate.filledOrders = response.data || []
            ref.redrawOrderArrows()
            // ref.botOrders = response.data
            // ref.botName = botName
            // ref.botSymbol = botSymbol
            // ref.botOrdersModalShow = true
          } else {
            // error
            ref.$Notice.error({
              title: ref.$text.tr('Ошибка'),
              desc: Util.returnTextForErr(response.data.err),
              duration: 10
            })
          }
        } else {
          // ref.$Notice.info({
          //   title: 'нет ордеров',
          //   duration: 1
          // })
        }
      }).catch(function (error) {
        // error
        console.log(error)
        ref.$Notice.error({
          title: ref.$text.tr('Ошибка'),
          desc: Util.returnTextForErr(error),
          duration: 10
        })
      })
    },
    saveBot () {
      if (this.eb.editBot.Id) {
        Bots.SaveBot().then(response => {
          // console.log('bot saved', response.data)
          if (!response.data.err) {
            this.$Message.success({
              content: this.$text.tr('Cохранено'),
              duration: 1
            })
          } else {
            this.$Notice.error({
              title: this.$text.tr('Ошибка'),
              desc: Util.returnTextForErr(response.data.err),
              duration: 10
            })
          }
          this.$store.state.bots.botsUpdated = Date.now()
          Bots.UpdateBotBalance()
        }).catch(function (error) {
          console.log(error)
        })
      }
    },
    saveViewModeBot (bot) {
      Bots.SaveViewModeBot(bot).then(response => {
        // console.log('saveViewModeBot saved', JSON.stringify(response.data))
        if (!response.data.err) {
          this.$Message.success({
            content: this.$text.tr('Cохранено'),
            duration: 1
          })
        } else {
          this.$Notice.error({
            title: this.$text.tr('Ошибка'),
            desc: Util.returnTextForErr(response.data.err),
            duration: 10
          })
        }
        this.$store.state.bots.botsUpdated = Date.now()
        Bots.UpdateBotBalance()
      }).catch(function (error) {
        console.log(error)
      })
    },
    redrawOrderArrows () {
      if (!pstate.tvWidget || !pstate.tvWidget._ready || !pstate.tvWidget.chart()) return
      this.cleanArrows()
      if (this.eb.showArrows === false) {
        return
      }
      pstate.filledOrders.forEach(order => {
        this.addOrderArrowShape(order)
      })
    },
    addOrderArrowShape (order) {
      if (!order.Executed) {
        return
      }
      if (!pstate.tvWidget || !pstate.tvWidget._ready || !pstate.tvWidget.chart()) {
        return
      }
      // console.log('add bot arrow', order.Executed)
      const shape = order.Side === 'B' ? 'arrow_up' : 'arrow_down'
      // var sign = trade.Side === 'B' ? '+' : '-'
      // var clr = order.Side === 'B' ? '#0F0' : '#ff0137'
      const time1 = new Date(order.Executed)
      // console.log('time1', time1, time1.getTime() / 1000)
      const arrow = pstate.tvWidget.chart().createShape(
        {
          time: time1.getTime() / 1000,
          price: parseFloat(order.Price)
        }, {
          shape,
          lock: true,
          zOrder: 'top',
          disableSelection: true,
          disableSave: true,
          disableUndo: true,
          showInObjectsTree: false
        })

      // pstate.orderArrows.push(arrow)
      pstate.orderArrows.push(arrow)
      // console.log('arrowShape added', arrow)

      // .setFont('10pt Verdana')
      // .setPrice(parseFloat(trade.Price))
    },
    addOrderArrow (order) {
      if (!order.Executed) {
        return
      }
      if (!pstate.tvWidget || !pstate.tvWidget._ready || !pstate.tvWidget.chart()) {
        return
      }
      // console.log('add bot arrow', order.Executed)
      const direction = order.Side === 'B' ? 'buy' : 'sell'
      // var sign = trade.Side === 'B' ? '+' : '-'
      const clr = order.Side === 'B' ? '#0F0' : '#ff0137'
      const time1 = new Date(order.Executed)
      // console.log('time1', time1, time1.getTime() / 1000)
      const arrow = pstate.tvWidget.chart().createExecutionShape()
      // .setText(sign + buy.Qty + ' ' + trade.Symbol.split('_')[0])
      // .setTooltip('')
      // .setTextColor('rgba(0,255,0,0.5)')
        .setTextColor(clr)
        .setArrowColor(clr)
        .setDirection(direction)
        .setTime(time1.getTime() / 1000)
        .setArrowHeight(16)
        .setArrowSpacing(2)
        // .setFont('10pt Verdana')
      // .setPrice(parseFloat(trade.Price))
      pstate.orderArrows.push(arrow)
    },
    addViewModeBuySellLine (bot) {
      if (!this.tvReady || !pstate.tvWidget || !pstate.tvWidget._ready || !pstate.tvWidget.chart()) {
        return
      }
      let color = '#20b2aa'
      let text = ' BUY ' + bot.BuyPrice
      let price = bot.BuyPrice
      if (bot.Stage === 'WAITSELL') {
        text = ' SELL ' + bot.SellPrice
        price = bot.SellPrice
        color = '#f08080'
      }
      const ref = this

      // console.log('viewModeBuySellLines before add', JSON.stringify(bot))
      const viewModeBuyLine = pstate.tvWidget.chart().createOrderLine()
        .setText(text)
        .setPrice(parseFloat(price))
        .setQuantity(bot.Id)
        .setLineWidth(1)
        .setLineStyle(2)
        .setLineLength(1)
        .setLineColor(color)
        .setBodyBorderColor(color)
        .setBodyBackgroundColor('#ffffff')
        .setBodyTextColor(color)
        .setQuantityBorderColor(color)
        .setQuantityBackgroundColor(color)
        .setCancelButtonBorderColor(color)
        .setCancelButtonIconColor(color)
        .onModify('onModify called', function (text) {
          ref.eb.editBot = bot
          ref.eb.editMode = true
        })
        .onCancel('onCancel called', function (text) {
          // ref.eb.stopLoss = false
          // ref.saveBot()
          Bots.CancelBot(bot.Id, this)
        })
        .onMove(function () {
          // this.setText('onMove')
          const priceDec = ref.$store.state.data.symbolsfilter[ref.eb.symbol].PriceDec
          if (bot.Stage === 'WAITSELL') {
            bot.SellPrice = new Decimal(this.getPrice()).toDP(priceDec, Decimal.ROUND_HALF_UP).toString()
            this.setText(' SELL ' + bot.SellPrice)
          } else {
            bot.BuyPrice = new Decimal(this.getPrice()).toDP(priceDec, Decimal.ROUND_HALF_UP).toString()
            this.setText(' BUY ' + bot.BuyPrice)
          }
          ref.saveViewModeBot(bot)
        })
      pstate.viewModeBuySellLines.push(viewModeBuyLine)
      // console.log('viewModeBuySellLines added', bot.Id)
    },
    addOtherBotSellLine (bot) {
      if (!this.tvReady || !pstate.tvWidget || !pstate.tvWidget._ready || !pstate.tvWidget.chart()) {
        return
      }
      const ref = this
      const color = 'rgba(64,28,44, 0.9)'
      const lineColor = '#D3D3D3'
      const otherBuyLine = pstate.tvWidget.chart().createOrderLine()
        .setText(' SELL ' + bot.SellPrice)
        .setPrice(parseFloat(bot.SellPrice))
        .setQuantity(bot.Id)
        .setLineWidth(1)
        .setLineStyle(2)
        .setLineLength(1)
        .setLineColor(lineColor)
        .setBodyBorderColor(color)
        .setBodyBackgroundColor('#ffffff')
        .setBodyTextColor(color)
        .setQuantityBorderColor(color)
        .setQuantityBackgroundColor(color)
        .setCancelButtonBorderColor(color)
        .setCancelButtonIconColor(color)
        .onModify('onModify called', function (text) {
          // console.log('bot modify', JSON.stringify(bot))
          ref.eb.editBot = bot
        })
      pstate.otherBuySellLines.push(otherBuyLine)
      // console.log('addOtherBotSellLine added', bot.SellPrice)
    },
    addOtherBotBuyLine (bot) {
      if (!this.tvReady || !pstate.tvWidget || !pstate.tvWidget._ready || !pstate.tvWidget.chart()) {
        return
      }
      const ref = this
      const color = 'rgba(13,56,18, 0.9)'
      const lineColor = '#D3D3D3'
      const otherBuyLine = pstate.tvWidget.chart().createOrderLine()
        .setText(' BUY ' + bot.BuyPrice)
        .setPrice(parseFloat(bot.BuyPrice))
        .setQuantity(bot.Id)
        .setLineWidth(1)
        .setLineStyle(2)
        .setLineLength(1)
        .setLineColor(lineColor)
        .setBodyBorderColor(color)
        .setBodyBackgroundColor('#ffffff')
        .setBodyTextColor(color)
        .setQuantityBorderColor(color)
        .setQuantityBackgroundColor(color)
        .setCancelButtonBorderColor(color)
        .setCancelButtonIconColor(color)
        .onModify('onModify called', function (text) {
          ref.eb.editBot = bot
        })
      pstate.otherBuySellLines.push(otherBuyLine)
      // console.log('otherBuyLine added', bot.BuyPrice)
    },
    // saveNeeded () {
    //   // console.log('BOT onAutoSaveNeeded')
    //   pstate.tvWidget.save(this.saveTV)
    // },
    // saveTV (state) {
    //   let statestr = JSON.stringify(state)
    //   if (statestr === this.prevState) {
    //     // console.log('tvdata save skipped')
    //     return
    //   }
    //   var md = new MobileDetect(window.navigator.userAgent)
    //   if (md.mobile()) {
    //     return
    //   }
    //   Api.post('user/tvdata?cmd=save&token=' + this.$store.state.sys.token, state)
    //     .then(res => {
    //       // console.log(res)
    //       this.prevState = statestr
    //       // console.log('tvdata saved', state)
    //     })
    //     .catch(error => {
    //       console.log(error)
    //     })
    // },
    addBotTriggerLine () {
      if (!pstate.tvWidget || !pstate.tvWidget._ready || !pstate.tvWidget.chart()) {
        return
      }
      if (!this.eb.triggerPrice) {
        return
      }

      if (!this.eb.editMode && this.eb.showOrders) {
        return
      }

      if (pstate.triggerLine) {
        pstate.triggerLine.remove()
        pstate.triggerLine = null
      }

      if (!this.eb.trigger) {
        return
      }

      const ref = this
      const color = '#4746b2'
      pstate.triggerLine = pstate.tvWidget.chart().createOrderLine()
        .setText(' TRIGGER ' + this.eb.triggerPrice)
        .setPrice(parseFloat(this.eb.triggerPrice))
        .setQuantity('')
        .setLineStyle(2)
        .setLineLength(1)
        .setLineColor(color)
        .setBodyBorderColor(color)
        .setBodyBackgroundColor('#ffffff')
        .setBodyTextColor(color)
        .setQuantityBorderColor(color)
        .setQuantityBackgroundColor(color)
        .setCancelButtonBorderColor(color)
        .setCancelButtonIconColor(color)

      // if (this.eb.editBot.Stage !== 'WAITSELL') {
      pstate.triggerLine = pstate.triggerLine.onMove(function () {
        // this.setText('onMove')
        const priceDec = ref.$store.state.data.symbolsfilter[ref.$store.state.bots.symbol].PriceDec
        ref.eb.triggerPrice = new Decimal(this.getPrice()).toDP(priceDec, Decimal.ROUND_HALF_UP).toString()
        ref.saveBot()
      })
        .onModify('onModify called', function (text) {
          // this.setText('onModify')
        })
        .onCancel('onCancel called', function (text) {
          ref.eb.trigger = false
          ref.saveBot()
        })
      // }
    },
    addBotSlLine () {
      if (!pstate.tvWidget || !pstate.tvWidget._ready || !pstate.tvWidget.chart()) {
        return
      }
      if (!this.eb.slPrice) {
        return
      }

      if (!this.eb.editMode && this.eb.showOrders) {
        return
      }

      if (pstate.slLine) {
        pstate.slLine.remove()
        pstate.slLine = null
      }

      if (!this.eb.stopLoss) {
        return
      }

      const pct = new Decimal(this.eb.buyPrice).sub(this.eb.slPrice).mul(100).div(this.eb.buyPrice).toDecimalPlaces(1).abs().toString()

      const ref = this
      const color = '#f01ab3'
      pstate.slLine = pstate.tvWidget.chart().createOrderLine()
        .onMove(function () {
          const priceDec2 = ref.$store.state.data.symbolsfilter[ref.$store.state.bots.symbol].PriceDec
          ref.eb.slPrice = new Decimal(this.getPrice()).toDP(priceDec2, Decimal.ROUND_HALF_UP).toString()
          ref.saveBot()
        })
        .onModify('onModify called', function (text) {
          // this.setText('onModify')
        })
        .onCancel('onCancel called', function (text) {
          ref.eb.stopLoss = false
          ref.saveBot()
        })
        .setText(' SL ' + this.eb.slPrice + ' (-' + pct + '%)')
        .setPrice(parseFloat(this.eb.slPrice))
        .setQuantity('')
        .setLineStyle(2)
        .setLineLength(1)
        .setLineColor(color)
        .setBodyBorderColor(color)
        .setBodyBackgroundColor('#ffffff')
        .setBodyTextColor(color)
        .setQuantityBorderColor(color)
        .setQuantityBackgroundColor(color)
        .setCancelButtonBorderColor(color)
        .setCancelButtonIconColor(color)
    },
    addBotSellLine () {
      if (!this.eb.sellPrice || !pstate.tvWidget || !pstate.tvWidget._ready || !pstate.tvWidget.chart()) {
        return
      }

      if (!this.eb.editMode && this.eb.showOrders) {
        return
      }

      if (pstate.sellLine) {
        pstate.sellLine.remove()
        pstate.sellLine = null
      }
      const pct = new Decimal(this.eb.sellPrice).sub(this.eb.buyPrice).mul(100).div(this.eb.buyPrice).toDecimalPlaces(1).abs().toString()
      const ref = this
      const color = '#f08080'
      let title = ' SELL '
      if (!this.eb.editBot.Id) {
        title = ' NEW SELL '
      }
      // console.log('adding sell line')
      pstate.sellLine = pstate.tvWidget.chart().createOrderLine()
        .onMove(function () {
          // this.setText('onMove')
          const priceDec = ref.$store.state.data.symbolsfilter[ref.$store.state.bots.symbol].PriceDec
          ref.eb.sellPrice = new Decimal(this.getPrice()).toDP(priceDec, Decimal.ROUND_HALF_UP).toString()
          ref.saveBot()
        })
        .onModify('onModify called', function (text) {
          // this.setText('onModify')
        })
        .setText(title + this.eb.sellPrice + ' (+' + pct + '%)')
        .setPrice(parseFloat(this.eb.sellPrice))
        .setQuantity('')
        .setLineWidth(2)
        .setLineStyle(2)
        .setLineLength(1)
        .setLineColor(color)
        .setBodyBorderColor(color)
        .setBodyBackgroundColor('#ffffff')
        .setBodyTextColor(color)
        .setQuantityBorderColor(color)
        .setQuantityBackgroundColor(color)
        .setCancelButtonBorderColor(color)
        .setCancelButtonIconColor(color)
    },
    addBotBuyLine () {
      if (!this.eb.buyPrice || !pstate.tvWidget || !pstate.tvWidget._ready || !pstate.tvWidget.chart()) {
        return
      }

      if (!this.eb.editMode && this.eb.showOrders) {
        return
      }

      if (pstate.buyLine) {
        pstate.buyLine.remove()
        pstate.buyLine = null
      }

      let title = ' BUY '
      if (!this.eb.editBot.Id) {
        title = ' NEW BUY '
      }

      const ref = this
      const color = '#20b2aa'
      pstate.buyLine = pstate.tvWidget.chart().createOrderLine()
        .setText(title + this.eb.buyPrice)
        .setPrice(parseFloat(this.eb.buyPrice))
        .setQuantity('')
        .setLineWidth(2)
        .setLineStyle(2)
        .setLineLength(1)
        .setLineColor(color)
        .setBodyBorderColor(color)
        .setBodyBackgroundColor('#ffffff')
        .setBodyTextColor(color)
        .setQuantityBorderColor(color)
        .setQuantityBackgroundColor(color)
        .setCancelButtonBorderColor(color)
        .setCancelButtonIconColor(color)

      // if (this.eb.editBot.Stage !== 'WAITSELL') {
      pstate.buyLine = pstate.buyLine
        .onMove(function () {
          // this.setText('onMove')
          const priceDec = ref.$store.state.data.symbolsfilter[ref.$store.state.bots.symbol].PriceDec
          ref.eb.buyPrice = new Decimal(this.getPrice()).toDP(priceDec, Decimal.ROUND_HALF_UP).toString()
          ref.saveBot()
        })
        .onModify('onModify called', function (text) {
          // this.setText('onModify')
        })
      // }
      // console.log('addBotBuyLine added', this.eb.buyPrice)
    },
    createBotChart (tvdatastr) {
      const capicoAppBotTvInterval = 'capico_app_bot_tv_interval'
      let interval = localStorage.getItem(capicoAppBotTvInterval)
      if (!interval) {
        interval = '60'
      }
      const userId = sha256(this.$store.state.sys.email)
      // var md = new MobileDetect(window.navigator.userAgent)
      const disabledFeatures = ['header_symbol_search', 'timeframes_toolbar', 'header_compare']
      // if (md.mobile()) {
      //   disabledFeatures.push('left_toolbar')
      // }

      const widgetOptions = {
        debug: false,
        symbol: this.chartSymbol,
        datafeed: Botdatafeed, // our datafeed object
        interval,
        container: this.containerId,
        library_path: '/app/charting_library/',
        custom_css_url: '/app/chart.css',
        locale: this.$store.state.sys.lang,
        timezone: Util.getTimezone(),
        disabled_features: disabledFeatures,
        enabled_features: ['side_toolbar_in_fullscreen_mode'],
        charts_storage_url: process.env.VUE_APP_TV_URL,
        charts_storage_api_version: '1.1',
        client_id: 'capico.app',
        user_id: userId,
        fullscreen: false,
        // allow_symbol_change: false,
        autosize: true,
        studies_overrides: {},
        auto_save_delay: 15,
        load_last_chart: true,
        numeric_formatting: { decimal_sign: '.' },
        favorites: {
          intervals: ['1', '60', '1D'],
          chartTypes: ['Area', 'Candles']
        },
        theme: this.$store.getters.isThemeLight ? 'Light' : 'Dark',
        loading_screen: {
          foregroundColor: Util.getCssVariable('--color-accent'),
          backgroundColor: Util.getCssVariable('--color-chart')
        },
        overrides: {
          // "paneProperties.background": "#404364",
          // "paneProperties.vertGridProperties.color": "#363c4e",
          // "paneProperties.horzGridProperties.color": "#363c4e",
          'symbolWatermarkProperties.transparency': 90,
          // "scalesProperties.textColor": "#AAA",
          // "mainSeriesProperties.candleStyle.wickUpColor": "#336854",
          // "mainSeriesProperties.candleStyle.wickDownColor": "#7f323f",
          'mainSeriesProperties.showCountdown': true,
          // 'mainSeriesProperties.candleStyle.upColor': '#20b2aa',
          // 'mainSeriesProperties.candleStyle.downColor': '#f08080',
          'mainSeriesProperties.candleStyle.drawBorder': false,
          'paneProperties.vertGridProperties.style': 2,
          'paneProperties.horzGridProperties.style': 2

          // #404364
        }
      }

      // if (tvdatastr) {
      //   // console.log('tvdata applied')
      //   widgetOptions.saved_data = JSON.parse(tvdatastr)
      //   let symbol1 = this.$store.state.bots.symbol.replace('_', '/')
      //   // console.log('this.chartSymbol', this.chartSymbol, symbol1)
      //   if (widgetOptions.saved_data.charts[0].panes[0].sources[0].state.symbol) {
      //     widgetOptions.saved_data.charts[0].panes[0].sources[0].state.symbol = this.chartSymbol
      //     widgetOptions.saved_data.charts[0].panes[0].sources[0].state.shortName = symbol1
      //   }
      // }

      // eslint-disable-next-line
      const tvWidget = new widget(widgetOptions)

      pstate.tvWidget = tvWidget
      // console.log(window.TradingView.version())

      tvWidget.onChartReady(() => {
        // console.log('tv widget is ready')
        // this.$store.state.trade.tvEnabled = true
        // this.addButtons()
        // this.addBuyLine(this.$store.state.trade.qty)
        this.tvReady = true
        this.addButtons()

        tvWidget.subscribe('onAutoSaveNeeded', () => {
          tvWidget.saveChartToServer(null, (err) => console.log(err), { defaultChartName: 'Auto' })
        })

        // tvWidget.subscribe('onAutoSaveNeeded', this.saveNeeded)
        Util.applyChartOverrides(tvWidget, 'bots')

        setTimeout(() => {
          if (!this.eb.editMode) {
            this.getExecutedBotOrders()
          }
          this.addBotBuyLine()
          this.addBotSellLine()
          this.addBotSlLine()
          this.addBotTriggerLine()
          if (!this.eb.editMode) {
            this.addViewModeBuySellLines()
          }
        }, 1000)

        const subscr = tvWidget.chart().onDataLoaded()
        subscr.subscribe(null, () => {
          // console.log('onDataLoaded')
          this.redrawOrderArrows()
        })

        if (pstate.resetExmoInterval) {
          clearInterval(pstate.resetExmoInterval)
        }
        pstate.resetExmoInterval = setInterval(() => {
          if ($store.state.sys.tradeExchange.ExchId === 'EXM' && this.$route.name === 'bots') {
            Data.resetCacheBot()
            if (tvWidget._ready && tvWidget.chart()) {
              tvWidget.chart().resetData()
            }
          }
        }, 15000)

        // var subscrSymb = tvWidget.chart().onSymbolChanged()
        // subscrSymb.subscribe(null, () => {
        //   var newSymbol = tvWidget.chart().symbol().replace('/', '_').split(':')[1]
        //   // console.log('onSymbolChanged. cur symbol:', this.$store.state.bots.symbol, tvWidget.chart().symbol(), newSymbol)
        //   if (this.$store.state.bots.symbol !== newSymbol) {
        //     // console.log('forcing symbol change')
        //     this.$store.state.bots.symbol = newSymbol
        //     this.$store.state.trade.editTrade = null
        //   }
        // })

        // var subscrSymb = tvWidget.chart().onSymbolChanged()
        // subscrSymb.subscribe(null, () => {
        //   console.log('onSymbolChanged')
        //   // console.log('onSymbolChanged. cur symbol:', this.$store.state.bots.symbol, tvWidget.chart().symbol(), newSymbol)
        // })

        const subscr2 = tvWidget.chart().onIntervalChanged()
        subscr2.subscribe(null, (interval, obj) => {
          // console.log('onIntervalChanged', interval, obj)
          localStorage.setItem(capicoAppBotTvInterval, interval)
        })
      })
    }
  }
}
</script>
